import api from '../..'

export interface InactivationStatsResponse {
  inProgress: number
  notStarted: number
}

const getInactivationStats = (courseId: number) =>
  api
    .get<InactivationStatsResponse>(
      `administration/courses/${courseId}/inactivation_stats`
    )
    .then(({ data }) => data)

export default getInactivationStats
